import React, {useEffect, useState} from 'react';
import Dropdown from '../../../../Assets/Dropdown';

const StatComponent = ({sport, statObj, setStatObj, stats, dispCrit}) => {
    const [errs, setErrs] = useState([]);
    const [localStat, setLocalStat] = useState({...statObj});

    // Helper function to clear specific errors
    const clearError = (errorType) => {
        if (errs.includes(errorType)) {
            setErrs(prev => prev.filter(err => err !== errorType));
        }
    };

    const teamOptions = [
        { value: "home", label: "home team" },
        { value: "away", label: "away team" }
    ];

    const statTypeLabels = {
        "mlb": {
            "off": "hitting",
            "def": "pitching"
        },
        "nfl": {
            "off.rushing" : "offensive rushing",
            "off.passing": "offensive passing",
            "off.receiving": "offensive receiving",
            "off.general": "general offensive",
            "def.passing": "defensive passing",
            "def.tackles": "defensive tackles",
            "def.fumbles": "defensive fumbles",
            "def.general": "general defensive",
            "st.kicking": "special teams kicking"
        },
        "nba": {
            "off": "offensive",
            "def": "defensive",
            "gen": "general"
        },
    };

    const getStatLabel = (obj) => {
        try {
            return(`${obj.team} team average ${stats[obj.type][obj.stat]}`);
        } catch {
            return("");
        }
    };

    const handleFieldChange = (val, type) => {
        let objCopy = {...localStat};
        switch(type) {
            case "team":
                objCopy.team = val;
                if (val === "home" || val === "away") {
                    clearError("team");
                }
                break; 
            case "type": 
                objCopy.type = val;
                objCopy.stat = "";
                if (val in stats) {
                    clearError("statType");
                }
                break;
            case "stat": 
                objCopy.stat = val;
                if (objCopy.type in stats && val in stats[objCopy.type]) {
                    clearError("stat");
                }
                break;
        }
        const label = getStatLabel(objCopy);
        objCopy.label = label;
        setLocalStat(objCopy);
    };

    const checkErrs = () => {
        let tmpErrs = [];
        // team validation 
        if(localStat.team !== "home" && localStat.team !== "away") tmpErrs.push("team");
        // stat type & stat validation
        if(localStat.type in stats) {
            if(!(localStat.stat in stats[localStat.type])) tmpErrs.push("stat");
        } else {
            tmpErrs.push("statType");
        }
        setErrs(tmpErrs);
        return tmpErrs.length > 0;
    };

    // run whenever errs changes
    useEffect(() => {
        // get all elements previously in error state and remove class
        let prevErrs = document.getElementsByClassName("err");
        while(prevErrs.length) {
            prevErrs[0].classList.remove("err");
        }
        // add err class based on updated errs
        errs.forEach(err => {
            const elem = document.getElementById(err);
            if(elem) {
                elem.classList.add("err");
            }
        });
    }, [errs]);

    const validateSubmit = () => {
        let isErrs = checkErrs();
        if(!isErrs) {
            setStatObj(localStat);
            dispCrit();
        }
    };

    const getStatTypeOptions = () => {
        return Object.keys(stats).map(key => ({
            value: key,
            label: statTypeLabels[sport][key]
        }));
    };

    const getStatOptions = () => {
        if (!localStat.type) return [];
        return Object.keys(stats[localStat.type]).map(stat => ({
            value: stat,
            label: stats[localStat.type][stat]
        }));
    };

    return (
        <div className="space-y-6">
            <div className="border-b border-gray-200 dark:border-gray-700 pb-5">
                <h2 className="text-xl font-semibold leading-6 text-gray-900 dark:text-white">
                    Choose Stat
                </h2>
                <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                    Select the team and statistical criteria you want to track.
                </p>
            </div>

            <form className="space-y-6">
                <div>
                    <Dropdown
                        id="team"
                        title="Team"
                        items={teamOptions}
                        onSelect={(value) => handleFieldChange(value, "team")}
                        activeItem={localStat.team}
                        className={errs.includes('team') ? 'ring-2 ring-brand-red-500' : ''}
                    />
                </div>

                <div>
                    <Dropdown
                        id="statType"
                        title="Stat Type"
                        items={getStatTypeOptions()}
                        onSelect={(value) => handleFieldChange(value, "type")}
                        activeItem={localStat.type}
                        className={errs.includes('statType') ? 'ring-2 ring-brand-red-500' : ''}
                    />
                </div>

                {localStat.type !== "" && (
                    <div>
                        <Dropdown
                            id="stat"
                            title="Stat"
                            items={getStatOptions()}
                            onSelect={(value) => handleFieldChange(value, "stat")}
                            activeItem={localStat.stat}
                            className={errs.includes('stat') ? 'ring-2 ring-brand-red-500' : ''}
                        />
                    </div>
                )}

                <div className="flex items-center justify-end gap-3 pt-4">
                    <button
                        type="button"
                        onClick={() => dispCrit()}
                        className="rounded-md bg-white dark:bg-gray-800 px-4 py-2.5 text-sm font-semibold text-gray-900 dark:text-white shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={() => validateSubmit()}
                        className="rounded-md bg-brand-red-500 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-brand-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-red-500"
                    >
                        Save Stat
                    </button>
                </div>
            </form>
        </div>
    );
};

export default StatComponent;